var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9984 3.18514C31.7624 3.73184 30.4518 4.09088 29.1097 4.25039C30.5243 3.40439 31.583 2.07296 32.0886 0.504212C30.761 1.29424 29.3056 1.84791 27.7887 2.14741C26.7698 1.0572 25.4192 0.334166 23.9469 0.0907156C22.4747 -0.152735 20.9633 0.0970396 19.6476 0.801207C18.332 1.50537 17.2858 2.62448 16.6718 3.98455C16.0578 5.34461 15.9103 6.86944 16.2523 8.32196C13.5602 8.18703 10.9266 7.48745 8.52244 6.26863C6.11828 5.04981 3.99731 3.33901 2.29724 1.24729C1.69548 2.28089 1.37924 3.45586 1.38094 4.65188C1.38094 6.99931 2.5757 9.07314 4.39212 10.2873C3.31717 10.2535 2.26589 9.96319 1.32589 9.44063V9.52482C1.32622 11.0882 1.86721 12.6034 2.85714 13.8134C3.84707 15.0235 5.22502 15.8539 6.75736 16.164C5.75948 16.4344 4.71316 16.4743 3.69761 16.2806C4.12964 17.6263 4.9717 18.8031 6.10589 19.6465C7.24008 20.4898 8.60961 20.9573 10.0227 20.9835C8.61827 22.0865 7.0102 22.9019 5.29043 23.383C3.57066 23.8641 1.77292 24.0016 0 23.7875C3.09488 25.7778 6.69762 26.8345 10.3773 26.831C22.8316 26.831 29.6424 16.5137 29.6424 7.56593C29.6424 7.27452 29.6343 6.97988 29.6213 6.69171C30.947 5.73358 32.0911 4.54668 33 3.18676L32.9984 3.18514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.7db25d62c1e0612fef94c811e3d578fc.svg";
export { ForwardRef as ReactComponent };